import styled from 'styled-components';
import { green } from '../../styles/constants';

const LinkButton = styled.button`
  background: none;
  color: ${green};
  font-weight: 600;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
`;

export default LinkButton;
